module.exports = __webpack_public_path__ + "img/overlijden.fc240632.png";